<template>
  <main class="wrapper">
    <section class="tabs">
      <button :class = "{tab: true, active: toggleInformation === true}" @click="$router.push('/service/serviceInformation'); clickInformation()">
        Информация
      </button>
      <button :class = "{tab: true, active: togglePrices === true}" @click="$router.push('/service/servicePrice'); clickPrices()">
        Расценки
      </button>
    </section>
    <transition name="slide-pageTransition" mode="out-in">
      <router-view></router-view>
    </transition>
  </main>
</template>

<script>


import AppLine from "@/components/AppLine";
import {useRoute} from "vue-router";
import {ref} from "vue";

export default {
  setup() {
    const router = useRoute()

    let route = router.path
    let toggleInformation = ref (false)
    let togglePrices = ref (false)

    if (route === '/service/serviceInformation') {
      toggleInformation.value = true
    } else {
      togglePrices.value =true
    }

    function clickInformation() {
      toggleInformation.value = true
      togglePrices.value = false
    }

    function clickPrices() {
      toggleInformation.value = false
      togglePrices.value = true
    }

    return {
      toggleInformation,
      togglePrices,
      clickInformation,
      clickPrices,
    }

  },
  components: {AppLine}
}

</script>

<style scoped>

button {
  border: 0;
}

.tabs {
  margin-top: 20px;
  text-align: center;
}

h2 {
  font-family: 'Roboto', sans-serif !important;
}

h1 {
  color: white;
  font-weight: 800;
  text-align: left;
  padding-left: 20px;
  font-family: "Poppins", sans-serif !important;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h2  {
  text-align: center;
  color: green;
  font-weight: 800;
  padding-bottom: 20px;
  font-size: 2em;
}

@media (max-width: 1800px) {
  .tab {
    font-size: 1.5em;
  }

  .tab.active {
    font-size: 2.0em;
  }
}

@media (max-width: 1400px) {
  h1 {
    font-size: 1.5em;
  }
  .tab {
    width: 40vw;
    font-size: 1.2em;
  }

  .tab.active {
    font-size: 1.7em;
  }

  img {
    width: 100%;
  }
}

@media (max-width: 400px) {
  .tab {
    width: 50vw;
    font-size: 0.9em;
  }
  .tab.active {
    font-size: 1.1em;
  }
}

</style>